<template lang="html">
	<div :class='locked ? "index-projects locked" : "index-projects"'>
		<!-- <pre>{{data}}</pre> -->
		
		<template v-if='!items.length'>
			{{ data.nothing_to_show }}
		</template>
		
		<template v-else>
			<div class="row">
				<template v-for='(item, i) in items'>
					<template v-if="i < widthDocum" >
						<template v-if='!item.banner'>
							<transition name='up' appear>
								<div class="cols s_24 m_12 m___8 l___6" :style='order(item.order)'>
									<div class="li">
										<img :src='`${templatePath}img/pf-area.jpg`' alt="">
										
										<div class="image" :style='`background-image: url("${item.background}")`'></div>
										<div class="container">
											<div class="top">
												<div class="label">{{ item.label }}</div>
												<div class="date">{{ item.date }}</div>
											</div>
											
											<div class="header" v-html='item.header'></div>
											
											<div class="text" v-html='item.text'></div>
											
											<a :href='item.a.href'>
												<span class="circle">
													<svg class="svg1" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
														<path d="M0 0h24v24H0z" fill="none"/>
														<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
													</svg>
													<svg class="svg2" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
														<path d="M0 0h24v24H0z" fill="none"/>
														<path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
													</svg>
												</span>
												{{ item.a.text }}
											</a>
										</div>
									</div>
								</div>
							</transition>
						</template>
						<template v-else>
							<transition name='up' appear>
								<div :class='`${cols(item.size)}`' :style='order(item.order)'>
									<div :class='`li banner ${item.style}`'>
										<img :style='`width:${item.size ? "calc(50% - 15px)" : "100%"}`' :src='`${templatePath}img/pf-area.jpg`' alt="">
										
										<div class="image" :style='`background-image: url("${item.background}")`'></div>
										<div class="container">
											<div class="header" v-html='item.header'></div>
											<Form :dataParams='JSON.stringify(item.form)'></Form>
										</div>
									</div>
								</div>
							</transition>
						</template>
					</template>
				</template>
			</div>
		</template>

	</div>
</template>

<script>
module.exports = {
	props: ['data', 'merge', 'locked'],
	computed: {
		widthDocum() {
			let a;
			console.log(this.vw);
			 if (this.vw < 1024) {
				a = 4;
			} else if (this.vw < 1919) {
				a = 6;
			} else {
				a = 8;
			}

			return a;

		}
	},
	data() {
		return {
			items: [],
			templatePath: window.YAMASTERS_FRONTEND.templatePath,
			vw: window.innerWidth
		}
	},
	
	methods: {
		cols(size) {
			if(size) {
				let _640 = (24 / 2) * (size._640 > 2 ? 2 : size._640);
				let _1024 = (24 / 3) * (size._1024 > 3 ? 3 : size._1024);
				let _1366 = (24 / 3) * (size._1366 > 3 ? 3 : size._1366);
				let _1920 = (24 / 4) * (size._1920 > 4 ? 4 : size._1920);
				
				return `cols s_24 m_${_640} m___${_1024} l__${_1366} l___${_1920}`;
			}
			else {
				return 'cols s_24 m_12 m___8 l___6'
			}
		},
		order(order) {
			// console.log(order, this.vw);
			if(order) {
				if(this.vw < 480) {
					return `order: ${order._320}`;
				}
				else if(480 <= this.vw && this.vw < 640) {
					return `order: ${order._480}`;
				}
				else if(640 <= this.vw && this.vw < 768) {
					return `order: ${order._640}`;
				}
				else if(768 <= this.vw && this.vw < 1024) {
					return `order: ${order._768}`;
				}
				else if(1024 <= this.vw && this.vw < 1180) {
					return `order: ${order._1024}`;
				}
				else if(1180 <= this.vw && this.vw < 1366) {
					return `order: ${order._1180}`;
				}
				else if(1366 <= this.vw && this.vw < 1920) {
					return `order: ${order._1366}`;
				}
				else if(1920 <= this.vw) {
					// console.log('1920');
					return `order: ${order._1920}`;
				}
				else {
					return 'opacity: .2';
				}
			}
			else {
				return '';
			}
		},
		bx24_buy(item) {
			return {
				button_1: item.button
			}
		}
	},
	
	watch: {
		data() {
			// this.items = ;
			if(this.merge) {
				this.data.items.forEach(item => this.items.push(item));
			}
			else {
				this.items = this.data.items;
				// $('html, body').stop().animate({
				// 	scrollTop: $(this.$el).offset().top - 100
				// });
			}
		}
	},
	
	mounted() {
		window.addEventListener('resize', () => {
			this.vw = window.innerWidth;
		})
		// this.ww = $(window).width();
	},
}
</script>
 
<style lang="scss">
@import "scss/wanted";

.index-projects {
	
	& + .Pager {
		display: none;
	}
	
	.row {
		
		.up-enter-active, .up-leave-active {
			transition: all 1s;
		}
		.up-enter, .up-leave-to /* .fade-leave-active для <2.1.8 */ {
			opacity: 0;
			transform: translateY(20px);
		}
		 
		.li { 
			position: relative;
			border-radius: 3px;
			background-color: rgba(#30A0CC, 1);
			overflow: hidden;
			margin: 0 0 30px;
			
			img {
				width: 100%;
			}
			
			.image {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 1;
				background-position: center;
				background-repeat: no-repeat;
				background-size: cover;
				@include single-transition;
			}
			
			.container {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 3;
				display: flex;
				flex-direction: column;
			}
			
			&:not(.banner) {
				&:hover {
					&:after {
						opacity: 1;
					}
					
					.image {
						filter: blur(5px);
					}
					
					.container {
						opacity: 1;
						
						.top {
							.label {
								opacity: 1;
								@include translateY(0px);
							}
							
							.date {
								opacity: 1;
								@include translateY(-1px);
							}
						}
						
						.header {
							opacity: 1;
							@include translateX(0px);
						}
						
						.text {
							opacity: 1;
							@include translateY(0px);
						}
						
						a {
							opacity: 1;
							@include translateY(0px);
							@include pointer-events(auto);
							touch-action: auto;
						}
					}
				}
				
				&:after {
					content: '';
					display: block;
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					left: 0;
					background-color: rgba(#000, .3);
					z-index: 2;
					opacity: 0;
					@include single-transition;
				}
				
				.container {
					color: #fff;
					padding: 36px 30px 30px;
					background: linear-gradient(to bottom, rgba(#00ACF0, .5), rgba(#611CC4, .5));
					opacity: 0;
					@include single-transition;
					@include l_up {
						padding: 36px 40px 40px;
					};
					
					.top {
						display: flex;
						justify-content: space-between;
						opacity: .5;
						margin: 0 0 10px;
						flex: 0 0 auto;
						@include s___up {
							margin: 0 0 13px;
						};
						
						.label {
							text-transform: uppercase;
							font-size: 11px;
							letter-spacing: 1px;
							transition: all 300ms ease 900ms;
							opacity: 0;
							@include translateY(-10px);
						}
						
						.date {
							font-size: 12px;
							transition: all 300ms ease 1100ms;
							opacity: 0;
							@include translateY(10px);
						}
					}
					
					.header {
						font-size: 24px;
						line-height: 30px;
						font-family: $Circe_bold;
						margin: 0 0 19px;
						flex: 0 0 auto;
						@include translateX(10px);
						opacity: 0;
						transition: all 300ms ease 300ms;
						@include s___up {
							font-size: 26px;
							line-height: 34px;
						};
						@include l_up {
							margin: 0 0 23px;
						};
					}
					
					.text {
						line-height: 18px;
						font-size: 14px;
						flex: 1 1 auto;
						@include translateY(-10px);
						opacity: 0;
						transition: all 300ms ease 500ms;
						@include s___up {
							font-size: 16px;
							line-height: 20px;
						};
						@include m_up {
							line-height: 18px;
							font-size: 14px;
						};
						@include m__up {
							font-size: 16px;
							line-height: 20px;
						};
						@include m___up {
							line-height: 18px;
							font-size: 14px;
						};
						@include l_up {
							font-size: 16px;
							line-height: 22px;
						};
					}
					
					a {
						display: flex;
						position: relative;
						text-transform: uppercase;
						text-decoration: none;
						font-size: 10px;
						color: #fff;
						letter-spacing: 1px;
						// background: url('#{$imgPathSCSS}p-1.png') no-repeat left center;
						height: 24px;
						align-items: center;
						padding: 0 0 0 40px;
						flex: 0 0 auto;
						@include translateY(10px);
						@include pointer-events(none);
						touch-action: none;
						opacity: 0;
						transition: all 300ms ease 700ms;
						.circle{
							display: inline-block;
							width: 24px;
							height: 24px;
							border-radius: 50%;
							border: 1px solid white;
							text-align: center;
							position: absolute;
							left: 0px;

							overflow: hidden;
						}
						svg{
							fill: #fff;
							width: 17px;
							border-radius: 50%;
							position: relative;
							top: -1px;
						}
						.svg1{
							left: 0px;
						}
						.svg2{
							top: -30px;
							left: -20px;
						}
						&:hover {
							.svg1 {
								left: 20px;
								@include transition(all,1000ms,ease,0ms);
							}
							.svg2{
								left: 0px;
								@include transition(all,1000ms,ease,0ms);
							}
						}
					}				}
			}
			
			&.banner {
				
				img {
					@media (max-width: 639px) {
						width: 100% !important;
					}
				}
				
				&.tpl-1 {
					
					.container {
						padding: 24px 0 30px;
						justify-content: space-between;
						align-items: center;
						@include s___up {
							padding: 27px 0 35px;
						};
						@include m_up {
							padding: 24px 0 30px;
						};
						@include l_up {
							padding: 37px 0 45px;
						};
						
						.header {
							color: #191937;
							font-family: $Circe_light;
							text-align: center;
							font-size: 24px;
							line-height: 34px;
							@include s___up {
								font-size: 28px;
								line-height: 40px;
							};
							@include m_up {
								font-size: 24px;
								line-height: 34px;
							};
							@include l_up {
								font-size: 28px;
								line-height: 40px;
							};
							
							b {
								font-weight: normal;
								font-family: $Circe_bold;
							}
						}
						
						button {
							display: block;
							width: auto;
							font-size: 14px;
							color: #434349;
							text-transform: uppercase;
							letter-spacing: 1px;
							text-decoration: none;
							padding: 21px 30px 18px;
							border-radius: 30px;
							border: none;
							background-color: #FDD929;
							box-shadow: 0px 10px 30px 0px rgba(#000, 0.35);
							@include single-transition;
							
							&:hover {
								background-color: lighten(#FDD929, 5%);
								box-shadow: 0px 10px 30px 0px rgba(#000, 0.45);
							}
							
							&:active {
								background-color: darken(#FDD929, 10%);
								box-shadow: 0px 10px 30px 0px rgba(#000, 0.55);
							}
						}
					}
				}
				
				&.tpl-2 {
					
					.container {
						padding: 39px 30px 45px;
						justify-content: space-between;
						align-items: flex-start;
						@include m_up {
							padding: 44px 60px 58px;
						};
						@include l__up {
							padding: 64px 60px 80px;
						};
						@include l___up {
							padding: 75px 77px 75px;
						};
						
						.header {
							font-size: 30px;
							color: #fff;
							line-height: 37px;
							@include s___up {
								font-size: 48px;
								line-height: 68px;
							};
							@include m_up {
								font-size: 36px;
								line-height: 50px;
							};
							@include m__up {
								font-size: 48px;
								line-height: 68px;
							};
							@include m___up {
								font-size: 36px;
								line-height: 50px;
							};
							@include l_up {
								font-size: 48px;
								line-height: 68px;
							};
							@include l___up {
								line-height: 61px;
							};
							
							b {
								font-weight: normal;
								font-family: $Circe_bold;
							}
						}
						
						button {
							display: block;
							width: auto;
							background-color: transparent;
							font-size: 14px;
							color: #fff;
							text-transform: uppercase;
							letter-spacing: 1px;
							text-decoration: none;
							height: 67px;
							padding: 0 30px;
							border-radius: 33px;
							border: 1px solid #fff;
							@include single-transition;
							@include l___up {
								font-size: 18px;
								text-transform: none;
								letter-spacing: normal;
								border: 2px solid #fff;
								padding: 0 40px;
							};
							
							&:hover {
								background-color: #fff;
								color: #000;
							}
							
							&:active {
								background-color: darken(#fff, 10%);
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// index-projects.vue?1c67a25d